export default __webpack_public_path__ + "static/media/vBch.5dcf2ddc.svg";